/*
Import all child theme specific scripts here
*/
import testimonials from "./custom/testimonials.js";
//import cards from "./custom/cards.js";
import accordion from "./custom/accordion.js";
import animalsListing from "./custom/animals-listing.js";
import slider from "./custom/slider.js";
import "./libs/splide/splide_custom_simple_initialize.js"; // Import and execute team.js
import customCheckbox from "./custom/custom-checkbox.js";
import videoCarousel from "./custom/video-carousel.js";
import resourceCarousel from "./custom/resource-carousel.js";
import blog from "./custom/blog.js";
import customAnchor from "./custom/custom-anchor.js";
import modal from "./custom/popup-modal.js";
